import { useQuery } from "react-query";
import fetchJson from "./fetchJson";

const useFetchPopularFood = (pageNumber, pageSize) => {
  const API_KEY = process.env.REACT_APP_SPOONACULAR_API_KEY;

  const fetchPopularFood = async () => {
    const data = await fetchJson(
      `https://api.spoonacular.com/recipes/complexSearch?apiKey=${API_KEY}&sort=popularity&sortDirection=desc&addRecipeInformation=true&number=${pageSize}&offset=${
        (pageNumber - 1) * pageSize
      }`
    );
    return {
      results: data.results ?? [],
      totalResults: data.totalResults ?? 0,
    };
  };
  return useQuery(["popularFood", pageNumber, pageSize], fetchPopularFood, {
    refetchOnWindowFocus: false,
    staleTime: 60000, // cache for 1 minute
    keepPreviousData: true,
  });
};

export default useFetchPopularFood;
